import classNames from "classnames";
import React from "react";
import DateDisplay from "../../../components/DateDisplay";
import { TableLoadingRow } from "../../../components/tables/VirtualTable";
import { useCloseLoopGridData } from "../hooks/CloseLoopGridDataContext";
import CloseLoopGridActionColumn from "./CloseLoopGridActionColumn";
import { FixedCell } from "../../../components/tables/StandardTable";

export type CloseLoopGridRowProps = {
    index: number;
    style: {
        height: number | string;
        width: number | string;
    };
};

const CloseLoopGridRow = ({ index, style }: Readonly<CloseLoopGridRowProps>) => {
    const { data, excludeIds, toggleExclude } = useCloseLoopGridData();
    const { height, width } = style;

    let rowData = data[index];
    if (rowData == null)
        return <TableLoadingRow style={{ height }} />;

    const {
        applicationId,
        login,
        loginCreatedDate,
        lastLoginDate,
        isAjBell,
        masterAccountReference,
        masterAccountId,
        masterAccountName,
        applicationDescription,
        applicationDate,
        lastDealDate,
        statusDescription,
        statusDate,
        provider
    } = rowData;

    const isInExport = !excludeIds.includes(applicationId);

    return <tr className={classNames("align-middle", {
        'text-secondary': !isInExport
    })} style={{ height, width }}>
        <FixedCell className="text-truncate">
            <span>{login}</span>
        </FixedCell>
        <FixedCell className="text-truncate">
            <DateDisplay>
                {loginCreatedDate}
            </DateDisplay>
        </FixedCell>
        <FixedCell className="text-truncate">
            <DateDisplay>
                {lastLoginDate}
            </DateDisplay>
        </FixedCell>
        <FixedCell className="text-truncate">
            <span>{isAjBell ? "AJBS" : ""}</span>
        </FixedCell>
        <FixedCell className="text-truncate">
            <a href={`/client/${masterAccountId}`} className={classNames({
                'link-secondary': !isInExport
            })}>
                <span>{masterAccountReference} | {masterAccountName}</span>
            </a>
        </FixedCell>
        <FixedCell className="text-truncate">
            <p className="m-0 lh-1">
                <a href={`/administration/applications/${applicationId}/summary?source=close-loop`} className={classNames({
                    "link-secondary": !isInExport
                })}>
                    {applicationDescription}
                </a>
                <br />
                <DateDisplay className="fs-smallest">
                    {applicationDate}
                </DateDisplay>
            </p>
        </FixedCell>
        <FixedCell className="text-truncate">
            <DateDisplay>
                {lastDealDate}
            </DateDisplay>
        </FixedCell>
        <FixedCell className="text-truncate">
            <p className="m-0 lh-1">
                {statusDescription}
                <br />
                <DateDisplay className="fs-smallest">
                    {statusDate}
                </DateDisplay>
            </p>
        </FixedCell>
        <FixedCell className="text-truncate">
            {provider}
        </FixedCell>
        <FixedCell>
            <CloseLoopGridActionColumn
                toggleInclude={() => toggleExclude(applicationId)}
                isInExport={isInExport}
            />
        </FixedCell>
    </tr>;
};

export default CloseLoopGridRow;